import type {AdvertisingMessage} from './types';

export const advertisingMessages: AdvertisingMessage[] = [
    {text: 'Special offer — up to 50% off across all collections', to: '/catalog'},
    {text: 'Free shipping on orders over $100', to: '/delivery'},
    {text: 'New arrivals — V&L Seven collection is here', to: '/catalog/vl-seven'},
    {text: 'Complimentary gift wrapping at checkout', to: '/gifts'},
];
